import { render } from "./ObjectConfiguration.vue?vue&type=template&id=62cdd444"
import script from "./ObjectConfiguration.vue?vue&type=script&lang=js"
export * from "./ObjectConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__